/**
 * Item reducer
 */

import { cloneDeep } from "lodash";
import _merge from "lodash/merge";

import * as actionTypes from "../../actions/actionTypes";

const itemReducer = (state = {}, action) => {
  let items;
  try {
    items = action.response.entities.items;
  } catch (error) {
    // That's ok
  }

  switch (action.type) {
    case actionTypes.DELETE_ASSETS_SUCCESS: {
      const { response } = action;
      const deletedItemIds = response.result.items;
      if (!deletedItemIds?.length) return state;

      const newState = cloneDeep(state);
      deletedItemIds.forEach(id => {
        if (newState[id]) {
          newState[id].status = "deleted";
        }
      });
      return newState;
    }
    case actionTypes.RETRY_ASSET_FILE_SUCCESS:
    case actionTypes.REPLACE_ASSET_FILE_SUCCESS:
    case actionTypes.UPDATE_MOTION_ASSET_THUMBNAIL_SUCCESS:
    case actionTypes.EDIT_MULTIPLE_ASSET_TAGS_SUCCESS: {
      const assets = action.response.entities.assets;

      return Object.entries(state).reduce((newState, i) => {
        const [itemId, item] = i;
        newState[itemId] =
          item.asset && assets[item.asset.id] ? { ...item, asset: assets[item.asset.id] } : item;
        return newState;
      }, {});
    }
    case actionTypes.INSERT_ASSET_ITEM_SUCCESS:
    case actionTypes.INSERT_CHUNKED_ASSET_ITEM_SUCCESS:
    case actionTypes.SEARCH_KIT_SUCCESS:
    case actionTypes.SEARCH_SPACE_SUCCESS:
    default: {
      if (items) return _merge({}, state, items);
      return state;
    }
  }
};

export default itemReducer;

export const getItems = state => {
  return state.entities.items;
};

export const getItemsByUuid = state => uuids => {
  const items = getItems(state),
    uuidArray = typeof uuids === "string" ? [uuids] : uuids;

  return uuidArray.map(uuid => items[uuid]);
};

export const getItemCanEdit = state => uuid => {
  const items = getItems(state),
    item = items[uuid];

  if (!item) return false;
  if (item.version !== 0) return false;

  const kit = state.entities.kits[item.kitId];

  if (!kit || !kit.access) return false;
  if (!kit.access.permissions.includes("edit_content")) return false;

  return true;
};
